import axiosApi from "axios";
import {
  LocaleTransformRequest,
  TokenTransformRequest,
} from "@/configs/axios/AxiosTransforms";

const cancelTokens = {};

export function GetCancelToken(key) {
  cancelTokens[key] = new AbortController();
  return cancelTokens[key].signal;
}

export function CancelRequest(key) {
  if (cancelTokens[key]) {
    cancelTokens[key].abort();
  }
}

export const BaseUrl = () => {
  return import.meta.env.VITE_API_URL || "";
};

export const AxiosApi = (version = 1) => {
  return `api/v${version}`;
};

const Axios = axiosApi.create({
  baseURL: BaseUrl(),
  headers: {
    Accept: "Application/json",
  },
  transformRequest: [
    TokenTransformRequest,
    LocaleTransformRequest,
    ...axiosApi.defaults.transformRequest,
  ],
});

export default Axios;
